import { searchWord } from "../WordBase";

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

export interface GreekImpersonalVerb {
  type: "impersonalVerb";  // "onpersoonlijk werkwoord"
  ground: string;
  dutch: string;
}

export const GREEK_IMPERSONAL_VERBS: GreekImpersonalVerb[] = [
  {
    type: "impersonalVerb",
    ground: "ἔξεστι(ν)",
    dutch: "het is mogelijk, het is toegelaten",
  },
  {
    // https://en.wiktionary.org/wiki/%CE%B4%CE%B5%E1%BF%96
    type: "impersonalVerb",
    ground: "δεῖ",
    dutch: "het is nodig",
  },
  {
    // https://en.wiktionary.org/wiki/%CF%87%CF%81%CE%AE
    type: "impersonalVerb",
    ground: "χρή",
    dutch: "het is nodig",
  },
  {
    // https://en.wiktionary.org/wiki/%CF%83%CF%85%CE%BC%CE%B2%CE%B1%CE%AF%CE%BD%CE%B5%CE%B9
    type: "impersonalVerb",
    ground: "συμβαίνει",
    dutch: "het gebeurt",
  },
  {
    // https://en.wiktionary.org/wiki/%CE%B4%CE%BF%CE%BA%CE%B5%E1%BF%96
    type: "impersonalVerb",
    ground: "δοκεῖ μοι",
    dutch: "het komt me wenselijk voor",
  },
  {
    // https://en.wiktionary.org/wiki/%CF%80%CF%81%CE%BF%CF%83%CE%AE%CE%BA%CE%B5%CE%B9
    type: "impersonalVerb",
    ground: "προσήκει",
    dutch: "het past (te)",
  },
  // {
  //   type: "impersonalVerb",
  //   ground: "",
  //   dutch: "",
  // },
];

export const searchGreekImpersonalVerb = searchWord(GREEK_IMPERSONAL_VERBS, "Greek impersonal verb", "ground");